import React, { useState, useEffect } from 'react';

import { Modal, Table } from 'react-bootstrap';
import { CustomButton, Loading } from '../../../_common';
import {
    GetPartials,
    GetStageInfo,
    GetStagesByJobId,
    GetPartials_getPartials as Partials,
    GetStageSheet_getStageSheet_details as StageSheet,
    GetStageInfo_getStageInfo as Stages,
} from '../../../../types/schemaTypes';
import '../JobStageSummary.scss';
import StageSheetPartialModalRow from './StageSheetPartialModalRow';
import { GET_PARTIALS, GET_STAGE_INFO } from '../../../../graphql/client/queries';
import { useQuery } from '@apollo/client/react';
import {NumericFormat as NumberFormat} from 'react-number-format';

interface PartialBoxProps {
    index: number;
    stageSheetBoxId: number;
    proppantId: number;
    boxDesc: string;
    splitWeight: number;
    stageSheetId: number;
}

interface StageSheetPartialModalProps {
    jobId: number;
    stageSheetId: number;
    showStageSheetPartialModal: boolean;
    stageSheet: StageSheet;
    handleOnClose: () => void;
    handleOnSave: (boxList: PartialBoxProps[]) => void;
    mutationLoading: boolean;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
}

const StageSheetPartialModal = ({
    jobId,
    stageSheetId,
    showStageSheetPartialModal,
    stageSheet,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    modalError,
    setModalError,
}: StageSheetPartialModalProps): React.ReactElement => {
    const [count, setCount] = useState(0);
    const [boxCount, setBoxCount] = useState(0);

    const [showDelete, setShowDelete] = useState(false);
    const [boxList, setBoxList] = useState<PartialBoxProps[]>();

    const [duplicateError, setDuplicateError] = useState<number[]>();
    const [weightNotAnIntegerError, setWeightNotAnIntegerError] = useState<number[]>();
    const [weightOutOfBoundsError, setweightOutOfBoundsError] = useState<number[]>();
    const [stageError, setStageError] = useState<number[]>();

    useEffect(() => {
        setBoxList([]);
    }, []);

    const { loading: partialsLoading, error: partialsError, data: partialsData } = useQuery<GetPartials>(GET_PARTIALS, {
        variables: {
            boxDesc: parseInt(stageSheet.boxDesc ?? '0'),
            stageSheetBoxId: stageSheet.stageSheetBoxId,
        },
        fetchPolicy: 'network-only',
    });
    const partials: Partials[] = [];
    let boxWeight = 0;
    if (partialsData && partialsData.getPartials) {
        partialsData.getPartials.map((partial, index) => {
            if (partial) {
                partials.push(partial);
                if (index === 0) boxWeight = partial.loadWeight ?? 0;
                boxWeight = boxWeight + (partial.splitWeight ?? 0);
            }
        });
    }

    const { loading: stagesLoading, error: stagesError, data: stagesData } = useQuery<GetStageInfo>(GET_STAGE_INFO, {
        variables: {
            input: {
                jobId: jobId,
                proppantId: stageSheet?.proppantId,
            },
        },
        fetchPolicy: 'network-only',
    });
    const stages: Stages[] = [];
    if (stagesData && stagesData.getStageInfo) {
        stagesData.getStageInfo.map(stage => {
            if (stage) stages.push(stage);
        });
    }

    const onClickClose = () => {
        setModalError('');
        handleOnClose();
    };

    const onClickSave = () => {
        let err = false;
        setModalError('');

        if (boxList) {
            const tempWeightNotAnIntegerError: number[] = [];
            const tempWeightOutOfBoundsError: number[] = [];
            const tempStageError: number[] = [];
            const tempDuplicateError: number[] = [];

            for (const box of boxList) {
                if (box.splitWeight === -1) {
                    tempWeightNotAnIntegerError.push(box.index);
                    err = true;
                }

                if (box.stageSheetId === -1) {
                    tempStageError.push(box.index);
                    err = true;
                }

                for (const boxItem of boxList) {
                    if (
                        box.index !== boxItem.index &&
                        box.index > boxItem.index &&
                        box.boxDesc === boxItem.boxDesc &&
                        box.stageSheetId !== -1 &&
                        box.stageSheetId === boxItem.stageSheetId
                    ) {
                        tempDuplicateError.push(box.index);
                        err = true;
                    }
                }

                setWeightNotAnIntegerError(tempWeightNotAnIntegerError);
                setStageError(tempStageError);
                setDuplicateError(tempDuplicateError);

                if (!err) {
                    // stageDetails.push({
                    //     wellHead: stageToAdd.wellHead,
                    //     stageNum: stageToAdd.stageNum,
                    //     stageSheetDescrip: stageToAdd.stageSheetDescrip === 'Runsheet 1' ? 'RunSheet1' : 'RunSheet2',
                    // });
                }
            }

            let tempTotalWeight = 0;
            const uniqueBoxList = boxList?.filter((o, index, arr) =>
                arr.findIndex(item => item.index === o.index) === index
            );
            for (const box of uniqueBoxList) {
                tempTotalWeight = tempTotalWeight + box.splitWeight;
            }
            if (tempTotalWeight > boxWeight) {
                setModalError(`Total allocated weight should not be more than ${boxWeight} lbs`);
                err = true;
            }

            if (!err) {
                handleOnSave(uniqueBoxList);
            }
        }
    };

    const partialBoxRowElement = () => {
        boxList?.length === 0 ? showDelete && setShowDelete(false) : !showDelete && setShowDelete(true);
        const element: React.ReactElement[] = [];
        partials.map((partialBox, index) => {
            element.push(
                <StageSheetPartialModalRow
                    key={index}
                    index={index}
                    jobId={jobId}
                    stageSheetId={stageSheetId}
                    boxCount={boxCount}
                    setBoxCount={setBoxCount}
                    stageSheet={stageSheet}
                    stages={stages}
                    box={partialBox}
                    boxList={boxList}
                    setBoxList={setBoxList}
                    showDelete={partialBox.stageSheetId !== stageSheetId}
                    weightNotAnIntegerError={weightNotAnIntegerError}
                    setWeightNotAnIntegerError={setWeightNotAnIntegerError}
                    weightOutOfBoundsError={weightOutOfBoundsError}
                    setWeightOutOfBoundsError={setweightOutOfBoundsError}
                    stageError={stageError}
                    setStageError={setStageError}
                    duplicateError={duplicateError}
                    setDuplicateError={setDuplicateError}
                />,
            );
        });

        for (let index = 0; index < count; index++) {
            element.push(
                <StageSheetPartialModalRow
                    key={partials.length + index}
                    index={partials.length + index}
                    jobId={jobId}
                    stageSheetId={stageSheetId}
                    boxCount={boxCount}
                    setBoxCount={setBoxCount}
                    stageSheet={stageSheet}
                    stages={stages}
                    boxList={boxList}
                    setBoxList={setBoxList}
                    showDelete={true}
                    weightNotAnIntegerError={weightNotAnIntegerError}
                    setWeightNotAnIntegerError={setWeightNotAnIntegerError}
                    weightOutOfBoundsError={weightOutOfBoundsError}
                    setWeightOutOfBoundsError={setweightOutOfBoundsError}
                    stageError={stageError}
                    setStageError={setStageError}
                    duplicateError={duplicateError}
                    setDuplicateError={setDuplicateError}
                />,
            );
        }
        return element;
    };

    return (
        <Modal show={showStageSheetPartialModal} onHide={onClickClose} dialogClassName="AddStageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Allocate Partials</div>
                    {partials.length !== 0 && (
                        <div className="Partials-Load-Weight">
                            Box {stageSheet.boxDesc} - &nbsp;
                            <NumberFormat
                                value={partials[0].unAllocatedWeight ?? 0}
                                displayType={'text'}
                                thousandSeparator={true}
                            />
                            &nbsp; lbs
                        </div>
                    )}
                    <div className="AddStageModal-Error"> {modalError} </div>
                </Modal.Title>
            </Modal.Header>

            {stagesLoading || partialsLoading ? (
                <Modal.Body className="AddStageModal-Body">
                    <span className="AddStageModal-Loading">
                        <Loading />
                    </span>
                </Modal.Body>
            ) : (
                <Modal.Body className="AddStageModal-Body">
                    <CustomButton
                        title={'Add Row'}
                        onClick={() => {
                            setBoxCount(boxCount + 1);
                            setCount(count + 1);
                        }}
                    />

                    <Table striped bordered className="tabletest AddStageModal-Table">
                        <thead>
                            <tr>
                                <th>Stage</th>
                                <th>Weight Allocation</th>
                                <th>Delete</th>
                            </tr>
                        </thead>

                        <tbody data-bind="foreach: teams"> {partialBoxRowElement()} </tbody>
                    </Table>
                </Modal.Body>
            )}

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton title="Save" onClick={onClickSave} />
            </Modal.Footer>
        </Modal>
    );
};

export default StageSheetPartialModal;
